/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class TaxFeeSetupService {
  private getallregionsurl: string = environment.host + '/region';
  private taxFeeSetupUrl: string = environment.host + '/tax-config';
  private taxFeeSetupNewUrl: string = environment.host + '/taxation-config';
  private taxMetadataUrl: string = environment.host + '/tax/metadata';
  private feeMetadataUrl: string = environment.host + '/charges-fees/metadata';
  private overridesMetadata: string = environment.host + '/overrides';
  private flagsMetadata: string = environment.host + '/flag/metadata';
  private paymentTyeCodesUrl: string = environment.host + '/payment-type/metadata'; 
  private getSatesUrl: string = environment.host + '/sales-tax-states/metadata';
  private incomeSalesTaxMetadata: string = environment.host + '/taxes-sales/metadata';

  constructor(private http: HttpClient) {}

    public getTaxSetupMetadata() {
        return this.http.get(this.taxMetadataUrl.toString()).toPromise();
    }

    public getAllTaxFeeSetupList() {
        return this.http.get(this.taxFeeSetupUrl.toString()).toPromise();
    }

    public createUpdateTaxFeeSetup(payload: any) {
        return this.http.put(this.taxFeeSetupUrl.toString(), payload).toPromise();
    }

    public createUpdateTaxFeeSetupNew(payload: any) {
        return this.http.put(this.taxFeeSetupNewUrl.toString(), payload).toPromise();
    }

    public getAllTaxFeeSetupListNew() {
        return this.http.get(this.taxFeeSetupNewUrl.toString()).toPromise();
    }

    public getAllRegions() {
      return this.http.get(this.getallregionsurl.toString()).toPromise();
    }

    public getAllStates() {
        return this.http.get(this.getSatesUrl.toString()).toPromise();
    }

    public getChargesNdFeesMetadata(){
        return this.http.get(this.feeMetadataUrl.toString()).toPromise();
    }

    public getAllOverrides() {
        return this.http.get(this.overridesMetadata.toString()).toPromise();
    }

    public getAllFlags() {
        return this.http.get(this.flagsMetadata.toString()).toPromise();
    }

    public getAllFlagsTabType() {
        const URL=this.flagsMetadata+ '?tabType=flagpage/incometax';
        return this.http.get(URL.toString()).toPromise();
    }

    public getPaymentCodes() {
        return this.http.get(this.paymentTyeCodesUrl.toString()).toPromise();
    }

    public getIncomeSalesTaxMetadata() {
        return this.http.get(this.incomeSalesTaxMetadata.toString()).toPromise();
    }
}